var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "80px",
    height: "80px",
    fill: "#fc5c03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#fc5c03;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#fc5c03;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "18,7 22,7 27,22 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27,
    cy: 22,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5,
    cy: 22,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,14c4.4,0,8,3.6,8,8h6c0-4.4,3.6-8,8-8c0.8,0,1.7,0.1,2.4,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,11h-6l-0.4,0.6c-1.6,2.6-4.6,4-7.6,3.4l0,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoto);
export default __webpack_public_path__ + "static/media/moto.cf6aff6c9b0c61dc826802410ab2fc5a.svg";
export { ForwardRef as ReactComponent };